import CalendarDay from './CalendarDay';
import { injectIntl } from 'react-intl';

export default injectIntl(CalendarDay);



// WEBPACK FOOTER //
// ./src/components/atoms/CalendarDay/CalendarDayContainer.js